import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import packageJson from "../package.json";

const Login = lazy(() => import("./pages/login/login"));
const Layout = lazy(() => import("./layouts/main"));
const Index = lazy(() => import("./pages/landing"));
const CreateShipment = lazy(() => import("./pages/shipment/create"));
const ListShipment = lazy(() => import("./pages/shipment/list"));
const DetailShipment = lazy(() => import("./pages/shipment/detail"));
const CODList = lazy(() => import("./pages/cod/list"))

export default function App() {
  return (
    <Router basename={`/${packageJson.homepage}`}>
      <div className="font-sukhumvit">
        <Switch basename={`/${packageJson.homepage}`}>
          <Suspense fallback={<span>Loading...</span>}>
            <Route exact path="/login" component={Login} />
            <Route exact path="/" component={Index} />
            <PrivateRoute exact path="/create-shipment">
              <CreateShipment />
            </PrivateRoute>
            <PrivateRoute exact path="/list-shipment">
              <ListShipment />
            </PrivateRoute>
            <PrivateRoute exact path="/detail/:consignmentNo">
              <DetailShipment />
            </PrivateRoute>
            <PrivateRouteNoLayout exact path="/cod">
              <CODList />
            </PrivateRouteNoLayout>
          </Suspense>
        </Switch>
      </div>
    </Router>
  );
}

function PrivateRoute({ auth, children, ...rest }) {
  // let checkAuth = auth?.accessToken ? true : false;
  let checkAuth = true;

  return (
    <Route
      {...rest}
      render={() =>
        checkAuth ? <Layout>{children}</Layout> : <Redirect to={"/login"} />
      }
    />
  );
}
function PrivateRouteNoLayout({ auth, children, ...rest }) {
  // let checkAuth = auth?.accessToken ? true : false;
  let checkAuth = true;

  return (
    <Route
      {...rest}
      render={() =>
        checkAuth ? <>{children}</> : <Redirect to={"/login"} />
      }
    />
  );
}
